/**
 * Track a custom GA4 event.
 * Falls back silently if gtag is not loaded.
 */
export function trackEvent(eventName, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", eventName, params)
  }
}

/**
 * Track when a section becomes visible in the viewport.
 * Returns an IntersectionObserver callback ref.
 */
export function trackSectionView(sectionName) {
  if (typeof window === "undefined") return () => {}

  let tracked = false
  return (node) => {
    if (!node || tracked) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !tracked) {
          tracked = true
          trackEvent("section_view", { section: sectionName })
          observer.disconnect()
        }
      },
      { threshold: 0.3 }
    )

    observer.observe(node)
  }
}
